import React from 'react';
import { Box, Grid, Typography, Paper, Stack, Chip } from '@mui/material';
import { WorkHistory, Star } from '@mui/icons-material';
import { brand } from '../../theme/colors';
import VerifierCard from './VerifierCard';

const PreviousVerifiersTab = ({ verifiers, onHireClick, loading }) => {
  return (
    <Box>
      {/* Info Banner */}
      <Paper
        elevation={0}
        sx={{
          backgroundColor: '#f3f0ff',
          border: '1px solid #e0d7ff',
          borderRadius: 2,
          p: 2.5,
          mb: 3
        }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <WorkHistory sx={{ color: brand.primary, fontSize: 28 }} />
          <Box>
            <Typography variant="subtitle1" fontWeight={600} color={brand.primary}>
              Your Previous Verifiers
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Verifiers you've worked with before. Hire them again for consistent quality and familiarity with your projects.
            </Typography>
          </Box>
        </Stack>
      </Paper>

      {/* Results Count */}
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {verifiers.length} previous {verifiers.length === 1 ? 'verifier' : 'verifiers'}
      </Typography>

      {/* Verifier Grid */}
      {verifiers.length === 0 ? (
        <Box
          sx={{
            textAlign: 'center',
            py: 8,
            px: 3
          }}
        >
          <WorkHistory sx={{ fontSize: 64, color: '#ccc', mb: 2 }} />
          <Typography variant="h6" color="text.secondary" gutterBottom>
            No previous verifiers
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Once you hire and work with verifiers, they'll appear here for easy re-hiring.
          </Typography>
        </Box>
      ) : (
        <Grid container spacing={3}>
          {verifiers.map((verifier) => (
            <Grid item xs={12} sm={6} md={4} key={verifier.user_id}>
              <VerifierCard
                verifier={{
                  ...verifier,
                  has_worked_together: true
                }}
                onHireClick={onHireClick}
                isAIRecommended={false}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default PreviousVerifiersTab;
